<template>
  <BlogArticleContainer>
    If you are doing the same as all the other recruiters you will never stand out. That's why keep focusing all our work into Linkedin
    could not be the best idea.

    <h2>
      Everybody is sharing the same talent atention
    </h2>

    <p>
      The best candidates will receive tons of notifications from recruiters. Then, everyone will try to make his content pop and caugh the
      eyes of our applicants. This effect will make every piece of content more expensive to produce in the long term. Also, this is not
      going to change so expect even more competition in the future.
    </p>

    <h2>
      Top-notch candidates avoid Linkedin spam
    </h2>

    <p>
      Sometimes they will receive similar offers twice a week. This will reduce the value of your offer making hard to connect with the
      actual talent you need. So, like a drop in the whater your messages will get lost in an increasinly number of never opened
      notifications. Having tons of contacts in Linkedin is no longer the key to succed since everyone has lots of contacts themselves,
      Linkedin has become in an infinite scroll content site.
    </p>

    <h2>
      Most of the best talent detest social media
    </h2>

    <p>
      This is a mater of fact, many people detest social media and all the noise they bring to their lives, personal or professional one.
    </p>

    <p>
      Not everyone is a marketing genious that tries to bring traffic from a social network to his page and sell some product. Most of our
      targets are people that uses social network just to search a job once a while. This makes Linkedin a place where people with less
      experience will try to apply to all the offers but the most experienced ones will avoid the noise if they don't really need to.
    </p>

    <h2>Where are the best places to find the right candidate</h2>
    <p>
      We would need to innovate new ways and sites to find key people hidden in non-common places. The key part is to find places where
      people are just talking about their work and are less exposed to job offers spam. Those places have increased odds since most of users
      there won't be sieged by tons of offers.
    </p>

    <p>
      Also, you will be able to improve your filter of candidates since in sites like chats or communities they will be less or more active
      in their own communities.
    </p>

    <p>
      You can search in our <a href="https://jobboardy.com/sites">jobboardy sites database</a> the perfect community to find the right
      candidate.
    </p>
  </BlogArticleContainer>
</template>

<script>
import BlogArticleContainer from "@/blog/BlogArticleContainer";

export default {
  components: {
    BlogArticleContainer,
  },
};
</script>

<style></style>
